export const CDN_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL="https://mir-s3-cdn-cf.behance.net/project_modules/1400_opt_1/1fce9591801773.5e3b087d13b19.jpg";

export const MENU_API="https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId=";
// export const MENU_API= "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.2616084&lng=87.8491064&restaurantId=";
